import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Skeleton from '@material-ui/lab/Skeleton'
import {
  Paper,
  Container,
  Divider,
  IconButton,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  TextField,
  Grid,
} from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { DatePicker } from '@material-ui/pickers'
import EventIcon from '@material-ui/icons/Event'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import ReportsApi from '../../api/reports.api'
import NewFillButton from '../Core/NewFillButton'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import dayjs from 'dayjs'
import { awaitWithLoading } from '../../services/utils'
import './Reports.scss'
import { ApproveBorderauxDataPopup } from './ApproveBorderauxDataPopup'
export const SendBorderaux = () => {
  const [date, setDate] = useState()
  const { register, triggerValidation, errors, getValues } = useForm({
    mode: 'onChange',
  })
  const [borderauxData, setBorderauxData] = useState([
    {
      totalPremium: '',
      totalRemittance: '',
      totalSurcharge: '',
    },
  ])
  const [borderauxApprovePopup, setBorderauxApprovePopup] = useState(false)
  const sendReport = async () => {
    const values = getValues()
    const res = await awaitWithLoading(
      ReportsApi.sendBorderauxToGlobal(
        values['month'],
        values['transfer_number']
      )
    )
    if (res.ok) {
      EventEmitterService.dispatch(EventKey.ShowSuccess, {
        title: 'The report has been send successfully',
        body: 'The report was send to Global',
      })
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }
  const getReportData = async () => {
    const values = getValues()
    const res = await awaitWithLoading(
      ReportsApi.getBorderauxToGlobalData(
        values['month'],
        values['transfer_number']
      )
    )
    if (res.ok) {
      setBorderauxData(res.data)
      setBorderauxApprovePopup(true)
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  return (
    <Container className="margin-top-basic">
      <div className="text-promotion blue bold">Send Borderaux To Global</div>
      <Divider />
      <Grid spacing={6}>
        <div className="send-borderaux-objects-line">
          <Grid item sm={3}>
            <DatePicker
              label="Month"
              inputVariant="outlined"
              disableFuture
              inputRef={register}
              onChange={(e) => setDate(e)}
              value={date}
              name="month"
              views={['month', 'year']}
              InputProps={{
                disableUnderline: true,
                className: 'lightgrayblue',
                endAdornment: (
                  <InputAdornment>
                    <IconButton className="lightgrayblue">
                      <EventIcon fontSize={'small'} className="lightgrayblue" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item sm={6}>
            <TextField
              variant="outlined"
              className="margin-top-basic margin-bottom-basic margin-right-basic"
              label="Transfer Number"
              name="transfer_number"
              inputRef={register}
            />
          </Grid>
          <Grid item sm={2}>
            <NewFillButton flat green onClick={() => getReportData()}>
              Send Borderaux
            </NewFillButton>
          </Grid>
        </div>
      </Grid>
      <Divider />
      <ApproveBorderauxDataPopup
        borderauxData={borderauxData}
        openApprove={borderauxApprovePopup}
        onApprove={() => sendReport()}
        onClose={() => setBorderauxApprovePopup(false)}
      />
    </Container>
  )
}
